
import {Fetch} from "../../utils/storage"
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Pay from '../../utils/pay'


export default {
name: 'Order-detail',
components: {
Checker,
CheckerItem,
XButton,
Group,
Cell,
Confirm,
XInput
},
filters: {
/**
* @return {string}
*/
meetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
},

statusFilter(value) {
return {
to_pay:'待支付',
paid:'已支付',
canceled:'已取消',
refunded:'已退费',
}[value]
}
},
data () {
return {
Meeting:{},
Order:{},
OrderInfo:{},
OrderInvoice:{},
HotelOrder:{},
Ticket:{},
MeetingID: 0,
OrderID:0,
UserID:0,
emailAddConfirm: false,
emailChangeText: '',
PayTypeOptions: [
{key: 'wechat',value:'微信'},
{key: 'cash',value:'现金'},
{key: 'transfer',value:'转账'},
{key: 'card',value:'刷卡'},
],
CanChangeHotel: true,

MeetingReceiptOrders: [],
MeetingReceiptOrder: {},

OrderMeetingCertificates: []
}
},
async created () {
this.OrderID = this.$route.params["orderID"]
if (!this.OrderID) this.$router.go(-1)
this.OrderID = parseInt(this.OrderID)
this.UserID = Fetch("ID")
await this.fetchOrderDetail()
let _this = this
if (!!this.HotelOrder && this.HotelOrder.IsNeedDeposit > 0 && (this.HotelOrder.Status==='to_pay' || this.HotelOrder.Status==='refunded')){
this.$vux.confirm.show({
theme: 'ios',
confirmText:"缴纳房费",
cancelText:"稍后再说",
content: '<span style="font-size:20px">您选择了酒店预订，需要完成房费交纳后酒店才可为您预留房间。</span>',
async onConfirm () {
_this.handleHotelOrderPay()
}
})
}
},
methods: {
ParseTime,
async fetchOrderDetail() {
let res = await Api('GetOrderList',{
Data:{
ID:this.OrderID,
},
Preloads:[
{Column:'OrderInfo'},
{Column:'HotelOrder'},
{Column:'Ticket'},
{Column:'OrderInvoice'},
{Column:'CreditInfo'},
{Column: 'OrderMeetingReceipts'},
{Column: 'OrderMeetingCertificates'},
{Column: 'OrderInvoiceYongyou'}
]
})
if (res.data.List && res.data.List.length === 1) {
this.Order = res.data.List[0]
this.OrderInfo = this.Order.OrderInfo
this.HotelOrder = this.Order.HotelOrder
this.Ticket = this.Order.Ticket
this.OrderInvoice = this.Order.OrderInvoice
this.OrderInvoiceYongyou = this.Order.OrderInvoiceYongyou
if (this.Order.MeetingType === "training") {
this.MeetingReceiptOrders = this.Order.OrderMeetingReceipts.map(item => {
item.FieldsData = JSON.parse(item.FieldsData)
item.FeedBackPhotos = JSON.parse(item.FeedBackPhotos)
return item
})
}
this.OrderMeetingCertificates = this.Order.OrderMeetingCertificates || []
await this.fetchMeetingDetailWithID(this.Order.MeetingID)
} else {
this.$vux.toast.show({
text:'获取订单信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
async fetchMeetingDetailWithID(id) {
let res = await Api('GetMeetingList',{
Data: {
ID:id,
},
Preloads:[
{Column:'SubMeetings'},
{Column:'SubMeetings.Hotels'},
]
})
if (res.data.List && res.data.List.length == 1) {
this.Meeting = res.data.List[0]
this.SubMeeting = this.Meeting.SubMeetings.filter(item=>{
if (item.ID === this.Order.SubMeetingID){
return true
}
})
if (this.SubMeeting.length === 1){
this.SubMeeting = this.SubMeeting[0]
}
console.log(this.SubMeeting, this.SubMeeting && this.SubMeeting.Hotels && this.SubMeeting.Hotels.length > 0)
let startAt = new Date(this.Meeting.StartAt).getTime()
let now = new Date().getTime()
if ((startAt - now) < ( 1000 * 60 * 60 * 24 * 1) || (this.HotelOrder && (this.HotelOrder.Status ==='paid'))) {
this.CanChangeHotel = false
}
} else {
this.$vux.toast.show({
text:'获取会议信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
handleReceiptEdit(index) {
let id = this.MeetingReceiptOrders[index].ID
this.$router.push(`/order/order-meeting-receipt/detail/${id}`)
},
handleCertificateEdit(index) {
let ID = this.OrderMeetingCertificates[index].ID
this.$router.push(`/order/order-meeting-certificate/detail?ID=${ID}`)
},
handlePayTypeClick(value) {
let _this = this
if (value !== _this.Order.PayType && _this.Order.Status === 'to_pay') {
_this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认修改订单支付方式？</span>',
async onConfirm () {
await Api('UpdateOrder',{
ID: _this.Order.ID,
PayType: value
})
await _this.fetchOrderDetail()
_this.$vux.toast.show({
text: '支付方式修改成功！',
type: 'text',
width:'3rem'
})
}
})
}
},
async handleWechatPay() {
try{
let _this = this
let res = await Api('GetMeetingPreOrder', {
OrderID: this.OrderID
})

Pay.invoke(res.data,function (){
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">会议已报名并支付成功</p>
<span style="font-size:20px">您可打开"个人中心"，在"已支付会议"中查看报名信息，点击下方确认按钮返回"会议广场"</span>
`,
confirmText:"返回首页",
cancelText:"留在此页",
onConfirm(){
_this.$router.push({
path: '/'
})
},
onCancel() {
_this.fetchOrderDetail()
}
})
})
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})

}
},
handleOrderToInvoiceYongyou() {
let _this = this
if (!_this.Order.Fee) {
_this.$vux.toast.show({
text: '免费会议，不可开发票！',
type: 'text',
width: '3.5rem'
})
return
}
if (!!_this.OrderInvoiceYongyou && _this.OrderInvoiceYongyou.Status != 'make_out_fail')  {
_this.$vux.toast.show({
text: '已发起开票申请，如未收到发票请耐心等待！',
type: 'text',
width: '3.5rem'
})
return
}










_this.$router.push(`/order/invoice/apply/${_this.Order.ID}`)
},
async confirmInvoiceApply () {
try {
if (!this.$refs.emailAddInput.valid || !this.emailChangeText) {
this.$vux.toast.show({
text: '邮箱格式不正确！',
type: 'text',
width:'3rem'
})
return
}
let res = await Api('InvoiceApplyYongyou', {
OrderIDs: [this.Order.ID],
InvoiceTitle: this.Order.OrderInfo.InvoiceTitle,
InvoiceNum: this.Order.OrderInfo.InvoiceNum,

Email: this.emailChangeText
})
this.$vux.toast.show({
text: '发起开票成功，发票将会发送至您邮箱！',
type: 'text',
width: '3rem'
})
} catch (err) {
this.$vux.toast.show({
text: `发起开票请求失败：${err.message}`,
type: 'text',
width: '3rem'
})

}
this.emailAddConfirm = false
await this.fetchOrderDetail()

},
async cancelInvoiceApply () {
this.emailChangeText = ''
this.emailAddConfirm = false
},
handleOrderToInvoice() {
let _this = this
if (!_this.Order.Fee) {
_this.$vux.toast.show({
text: '免费会议，不可开发票！',
type: 'text',
width: '3.5rem'
})
return
}
let diff = new Date(_this.Meeting.StartAt).getTime() - new Date().getTime()
let diff1 = new Date().getTime() - new Date(_this.Meeting.InvoiceEndAt).getTime()
if (diff > 0 || diff1 > 0) {
_this.$vux.toast.show({
text: '现在不在可开取发票的时段！',
type: 'text',
width: '3.5rem'
})
return
}

this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认去开取发票？</span>',
async onConfirm() {
try {
let res = await Api('GetInvoiceUrl', {
OrderID: _this.Order.ID,
RedirectUrl: window.location.href
})
window.location.href = res.data.Url
} catch (err) {
_this.$vux.toast.show({
text: '获取发票授权地址失败！',
type: 'text',
width: '3rem'
})

}
}
})
},
handleOrderDelete() {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认删除该订单？删除后不可恢复！</span>',
async onConfirm() {
try {
await Api('DeleteOrder', {}, {}, [{Name: 'ID', Value: _this.Order.ID}])
_this.$vux.toast.show({
text: '订单已删除！',
type: 'text',
width: '3rem'
})
_this.$router.replace('/')
} catch (err) {
_this.$vux.toast.show({
text: '订单删除错误：'+err.message,
type: 'text',
width: '3rem'
})

}
}
})
},
async handleHotelOrderPay() {
try{

let _this = this
let res = await Api('GetHotelPreOrder', {
HotelOrderID: this.Order.HotelOrder.ID
})
Pay.invoke(res.data,function (){
_this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">酒店房费支付成功</span>',
showCancelButton:false,
onConfirm(){
_this.fetchOrderDetail()
}
})
})
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">获取支付请求失败：${err.message}</span>`,
showCancelButton:false,
})

}
},
handleHotelOrderRefund() {
let _this = this
_this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">酒店房费退换，请联系管理员:17610510599</span>',
confirmText:'拨打管理员电话',
async onConfirm() {
window.location.href = 'tel://' + "17610510599"
}
})









































},
async handleGoToLive(){
try {
let _this = this
let res = await Api('GetSubMeetingList',{
Data:{
ID:_this.Order.SubMeetingID,
}
})
switch(res.data.List[0].LiveResourceType){
case 'xiaoetong':
window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/4`
break;
case 'xiaoetong-zhuanlan':
window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/6`
break;
case 'tencent':
window.location.href = `http://enroll.admin.fuyouhuiyi.com/#/download/notice/file`
break;
case 'zoom':
window.location.href = `http://enroll.admin.fuyouhuiyi.com/#/download/notice/file`
break;
case 'third-part':
window.location.href = `${res.data.List[0].LiveResourceID}`
break;
default:
window.location.href = `https://zhibo.fuyouhuiyi.com/detail/${res.data.List[0].LiveResourceID}/4`


}
}
catch (err) {
this.$vux.toast.show({
text: '获取直播地址错误：'+err.message,
type: 'text',
width: '3rem'
})

}
},
handleOrderToTicket(id) {
this.$router.push(`/order/ticket/detail/${id}`)
},
handleSubmitJoin() {
let _this = this
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">会议报名成功</p>
<span style="font-size:20px">您可打开"个人中心"，在"待支付会议"中查看报名信息或修改支付方式。点击下方确认按钮返回"会议广场"</span>
`,
confirmText:"返回首页",
cancelText:"留在此页",
onConfirm(){
_this.$router.push({
path: '/'
})
},
onCancel() {
_this.fetchOrderDetail()
}
})
},
handleEditHotelOrderClick() {
let _this = this
if (!_this.CanChangeHotel) {
_this.$vux.confirm.show({
theme: 'ios',
content: `
<span style="font-size:20px;line-height: 34px;">当前已过会议酒店预订的<span style="color:darkred">截止时间</span>，不可修改酒店</span>
`,
showCancelButton:false
})
return
}
if(this.HotelOrder && _this.HotelOrder.Status ==="paid") {
_this.$vux.confirm.show({
theme: 'ios',
content: `
<span style="font-size:20px;line-height: 34px;">您已经交纳了该酒店的预订房费，需要先退还酒店房费后才可更改酒店信息！酒店房费退换，请联系管理员:17610510599</span>
`,
confirmText:"联系退费",
cancelText:"再想想",
async onConfirm() {
window.location.href = 'tel://' + "17610510599"
}
})
}else{
_this.$vux.confirm.show({
theme: 'ios',
content: `
<span style="font-size:20px;line-height: 34px;">点击<span style="color:darkred">去修改</span>，将跳转 <span style="color:darkred">"酒店信息修改"</span></span>
`,
confirmText:"去修改",
cancelText:"再想想",
async onConfirm() {
_this.$router.push(`/order/detail/hotel/edit/${_this.Order.ID}`)
}
})
}
},
on_annual_meeting_hotel_click() {
window.location.href = "https://application.qiyechailv.com/wap/hotel/hotelList.html?id=79"
}
},
}
